<template>
  <div>
    <div class="form-container">
      <p>{{ $t('folderProperties.requiredDocuments.form.label.line1') }}<p>
      <p>{{ $t('folderProperties.requiredDocuments.form.label.line2') }}</p>
      <p4a-textarea class="form-container__textarea"
                    v-model="requiredDocuments.textareaText"
                    :height="220"
                    :resizable="true"
                    :disabled="ReadOnly">
      </p4a-textarea>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    requiredDocuments: Object,
    ReadOnly: Boolean
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/folder/folderProperties/requiredDocuments.vue